import {createStore} from "vuex";

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {

    },
    state: {
        name: null,
        lang: null,
        fingerprint: null
    },
    mutations: {
        setName (state, name) {
            state.name = name;
        },
        clearName (state) {
            state.name = null;
        },
        SET_LANG (state, lang) {
            console.log("Store lang received is: " + lang);
            state.lang = lang;
        },
        SET_FINGERPRINT (state, fingerprint) {
            state.fingerprint = fingerprint;
        }
    },
    actions: {
        setName (context, name) {
            context.commit('setName', name);
        },
        clearName (context) {
            context.commit('clearName');
        },
        setLang (context, payload) {
            console.log(payload)
            context.commit('SET_LANG', payload.lang);
        },
        setFingerprint (context, payload) {
            console.log(payload)
            context.commit('SET_FINGERPRINT', payload.fingerprint);
        }
    },
    getters: {
        getName: (state) => {
            return state.name;
        },
        getLang: (state) => {
            return state.lang.slice(0,2);
        },
        getFingerprint: (state) => {
            return state.fingerprint;
        },
    },
    strict: debug,
});
